import * as angular from "angular";
import {ManageDefaultsController} from "./manage-defaults.controller.ts";
const templateUrl = require("./manage-defaults.html");

export const manageDefaults: angular.IDirective = {
    templateUrl: templateUrl,
    controller: ManageDefaultsController,
    controllerAs: "vm",
    bindToController: true,
    scope: {}
};


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/manage-defaults/manage-defaults.ts
 **/